import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';

const StatementDialog = ({ type, sessionId, onAcknowledge, onCancel }) => {
  const [pdfUrl, setPdfUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [acknowledging, setAcknowledging] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadPdf = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user/statement/${type}`, {
          headers: { 'session-id': sessionId }
        });
        
        if (response.ok) {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        } else {
          console.error(`Failed to load ${type} statement:`, response.status, response.statusText);
          const errorText = await response.text();
          console.error('Error response:', errorText);
          setError(`Failed to load ${type} statement (${response.status})`);
        }
      } catch (error) {
        setError(`Error loading ${type} statement: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    loadPdf();

    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [type, sessionId]);

  const handleAcknowledge = async () => {
    setAcknowledging(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/user/statement/${type}/acknowledge`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'session-id': sessionId
        }
      });

      if (response.ok) {
        onAcknowledge();
      } else {
        const errorText = await response.text();
        setError(errorText || `Failed to acknowledge ${type} statement`);
      }
    } catch (error) {
      setError(`Connection error: ${error.message}`);
    } finally {
      setAcknowledging(false);
    }
  };

  const title = type === 'legal' ? 'Legal Statement' : 'Privacy Statement';

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '90vw', height: '90vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <p style={{ margin: 0, color: '#666' }}>Please review and acknowledge this statement to continue.</p>
        </div>
        
        <div style={{ flex: 1, marginBottom: '1rem', border: '1px solid #ddd', borderRadius: '4px' }}>
          {loading ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <p>Loading {type} statement...</p>
            </div>
          ) : error ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '2rem' }}>
              <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>
              <p style={{ color: '#666', textAlign: 'center' }}>The {type} statement could not be loaded from the server. Please contact support if you need to review the document before acknowledging.</p>
            </div>
          ) : (
            <iframe
              src={pdfUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title={title}
            />
          )}
        </div>
        
        {error && (
          <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
            {error}
          </div>
        )}
        
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button 
            onClick={handleAcknowledge}
            disabled={acknowledging}
            style={{ 
              backgroundColor: '#28a745', 
              color: 'white', 
              border: 'none', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '4px', 
              cursor: acknowledging ? 'not-allowed' : 'pointer',
              fontSize: '1rem'
            }}
          >
            {acknowledging ? 'Acknowledging...' : `I Acknowledge This ${title}`}
          </button>
          <button 
            onClick={onCancel}
            disabled={acknowledging}
            style={{ 
              backgroundColor: '#6c757d', 
              color: 'white', 
              border: 'none', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '4px', 
              cursor: acknowledging ? 'not-allowed' : 'pointer',
              fontSize: '1rem'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatementDialog;